import { useEffect, useState } from "react";

export default ({ onDrag }) => {
  const [spaceDown, setSpaceDown] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);

  const isDraggable = spaceDown && mouseDown;

  /**
   * Detect space down
   */
  useEffect(() => {
    const keydown = (e) => {
      // ignore repeated events
      // if (e.repeat) {
      //   return;
      // }

      if (
        e.key === " " &&
        e.target.tagName.toLowerCase() !== "textarea" // prevents this behavior when editing text
      ) {
        setSpaceDown(true);

        if (e.target === document.body) {
          e.preventDefault(); // prevents scrolling of the body
        }
      }
    };

    const keyup = (e) => {
      // ignore repeated events
      // if (e.repeat) {
      //   return;
      // }

      if (e.key === " ") {
        setSpaceDown(false);
      }
    };

    const mousedown = (e) => {
      setMouseDown(true);
    };

    const mouseup = (e) => {
      // setTimeout(() => {
        setMouseDown(false);
      // }, 500);
    };

    document.addEventListener("keydown", keydown);
    document.addEventListener("keyup", keyup);
    document.addEventListener("mousedown", mousedown);
    document.addEventListener("mouseup", mouseup);

    return () => {
      document.removeEventListener("keydown", keydown);
      document.removeEventListener("keyup", keyup);
      document.removeEventListener("mousedown", mousedown);
      document.removeEventListener("mouseup", mouseup);
    };
  }, []);

  /**
   * Do the dragging
   */
  useEffect(() => {
    if (!isDraggable) {
      return;
    }

    const move = (e) => {
      onDrag(e.movementX, e.movementY);
    };

    // console.log("add mousedown event");
    document.body.addEventListener("mousemove", move);

    return () => {
      // console.log("remove mousedown event from render cycle");
      document.body.removeEventListener("mousemove", move);
    };
  }, [spaceDown, mouseDown]);

  return {
    isSpaceDown: spaceDown,
    isSpaceDragging: isDraggable,
  };
};
